const state = {
  sidebar: {
    opened: true,
    withoutAnimation: false,
  },
  permission_routes: [
    {
      name: "OrderForm",
      meta: {
        icon: "el-icon-menu",
        title: "营销检查管理",
      },
      path: "/orderForm",
      children: [
        {
          name: "OrderCheckResult",
          meta: {
            title: "订单检查结果查询",
          },
          path: "/orderForm/checkResult",
        },
        {
          name: "OrderFormSearch",
          meta: {
            title: "订单表单查询",
          },
          path: "/orderForm/search",
        },
      ],
    },
  ],
};

const actions = {
  closeSideBar({ commit }, { withoutAnimation }) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleSideBar({ commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  toggleDevice({ commit }, device) {
    commit("TOGGLE_DEVICE", device);
  },
};

const mutations = {
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
};

export default {
  namespaced: true,
  state,
  // getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/orderForm.js